export default function noop() {
  // No operation
}
